/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        //Sticky Nav Smooth transition
        $(document).scroll(function() {
            var stickyElement1 = $('.headerWrapper-desk');
            var y = $(document).scrollTop();
            if (y >= 100)  {
              //Add class
              stickyElement1.addClass('headerFixed');
              $('.headerSlider').addClass('headerSlider-padding');
            } else {
              //Remove class
              stickyElement1.removeClass('headerFixed');
              $('.headerSlider').removeClass('headerSlider-padding');
            }
        });

        //Search Function
        $(function(){
          $('.fa-search').click(function(){
              $('.overlay').css({'width': '100%'});
          });
          $('.closebtn').click(function(){
              $('.overlay').css({'width': '0'});
          });
        });

        //Mobile Nav
        $(function(){
          $('.headerRight-menu').click(function(){
              $('.headerNavigation--mobile').slideDown(1000);
          });
          $('.headerNavigation--mobile-exit').click(function(){
              $('.headerNavigation--mobile').slideUp(1000);
          });
        });

        //header swiper slider
        $(document).ready(function () {
          //Top Image
          var swiperImage = new Swiper('.swiper-main', {
            simulateTouch: false,
          });
          var swiperTestimonials = new Swiper('.swiper-testimonials', {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
          });
          var swiperAbout = new Swiper('.swiper-about', {
            slidesPerView: 3,
            spaceBetween: 30,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
          });
        });

        //Activity Page bootstrap
        $('#myModal').on('shown.bs.modal', function () {
          $('#myInput').trigger('focus');
        });

        //Twitter load More
        $(function(){
          //set number of posts shown
          var intViewportWidth = window.innerWidth;
          if (intViewportWidth <= 768) {
              var twitterClick = 2;
          } else {
              var twitterClick = 6;
          }
          //if window viewport

          $('.homeActivities-twitterLoad').click(function(){
            //increase by 2 to load  2 each click
            twitterClick += 2;
            $('.homeActivities-twitterPost:lt('+twitterClick+')').css('display', 'block');
            console.log(twitterClick);
            //If no more posts
            if (twitterClick == 12) {
                //no more posts to load
                $('.homeActivities-twitterLoad').text('No More Posts To Show');
            }
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
